import axios from 'axios';
import { currentHttpOptions } from '../../utils';

const API_URL = '/api/v1/common';
/**
 * @returns {Promise<ApiCommon.GetSymbolicPeriodListResponse>}
 */
export const getSymbolicPeriodList = (includeShiftRelativePeriods = false) => axios.get(`${process.env.REACT_APP_API_DOTNET}${API_URL}/SymbolicPeriod?includeShiftRelativePeriods=${includeShiftRelativePeriods}`,
    currentHttpOptions());

